<template>
  <v-card class="mb-8">
    <v-card-title primary-title class="py-2">
      <v-toolbar-title>{{ $t("view.commons.records") }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon style="margin: 0" @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-expand-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="py-0">
        <v-layout row wrap>
          <v-flex md12>
            <filters ref="filters" @filter="filter" />
          </v-flex>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              item-key="clave"
              class="validator dataTable"
              sort-by="clave"
              show-expand
              :sort-desc="true"
              :headers="computedHeaders"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :single-expand="false"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options"
              :expanded.sync="expanded">
              <template #top>
                <v-text-field v-model.trim="search" dense hide-details :label="$t('view.commons.search')" append-icon="mdi-magnify" />
              </template>

              <template #footer.prepend>
                <v-btn fab x-small color="primary" elevation="0" class="btn_tippy mr-3" :title="$t('view.commons.reload')" :loading="view.elem.datatable.loading" @click="load">
                  <v-icon x-small>fas fa-sync-alt</v-icon>
                </v-btn>
                <v-switch v-model="autoreload" input-value="true" color="primary" :label="$t('view.commons.autoreload')" />
              </template>

              <template #item.data-table-expand="{ item, expand, isExpanded }">
                <button
                  v-if="[VACH_STATUS_NUM_ERROR, VACH_STATUS_NUM_ERROR_ENVIO].includes(item.estatus) && item.detalle && !item.detalle.includes('{')"
                  type="button"
                  class="v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light"
                  :class="!isExpanded ? 'v-data-table__expand-icon--active' : ''"
                  @click="expand(!isExpanded)"></button>
              </template>

              <template #item.clave="{ item }">
                <em class="btn_tippy" :class="VACH_STATUS_TABLE[item.estatus].icon" :title="VACH_STATUS_TABLE[item.estatus].name" :style="`color:${VACH_STATUS_TABLE[item.estatus].color};`" />
                &nbsp;
                {{ item.clave }}
                &nbsp;
                <em v-if="item.fechaMail" class="fas fa-envelope" style="color: green" />
              </template>

              <template #item.fecha="{ item }">
                {{ formatDateTime(item.fecha) }}
              </template>

              <template #item.estatus="{ item }">
                {{ VACH_STATUS[parseInt(item.estatus)] ? VACH_STATUS[parseInt(item.estatus)] : "" }}
              </template>

              <template #item.accion="{ item }">
                <buttonCustom
                  :ref="`dataTableBtnDetalle_${item.clave}`"
                  :paramtype="'Object'"
                  :paramobj="item"
                  :showcustom="![VACH_STATUS_NUM_PENDIENTE, VACH_STATUS_NUM_PROCESO].includes(item.estatus) && item.detalle && item.detalle.includes('{')"
                  action="detail"
                  icon="fas fa-search"
                  :title="$t('view.commons.detail')"
                  @detail="detail" />

                <buttonDisable
                  :ref="`dataTableBtnDisable_${item.clave}`"
                  :clave="item.clave"
                  :showdisable="!item.enviarsft && ![VACH_STATUS_NUM_PENDIENTE, VACH_STATUS_NUM_PROCESO].includes(item.estatus)"
                  :isdelete="true"
                  :loading="loading.includes(item.clave)"
                  :clase="loading.length > 0 ? 'loading' : ''"
                  @disable="disable" />

                <buttonDownload
                  :ref="`dataTableBtnDownload_${item.clave}`"
                  :clave="item.clave"
                  :loading="loading.includes(item.clave)"
                  :clase="loading.length > 0 ? 'loading' : ''"
                  @download="download" />

                <ButtonErrors
                  :ref="`dataTableBtnErrors_${item.clave}`"
                  :showerrors="item.estatus == VACH_STATUS_NUM_ERROR && item.detalle && item.detalle.includes('{')"
                  :clave="item.clave"
                  :loading="loading.includes(item.clave)"
                  @errors="errors" />

                <buttonCustom
                  :ref="`dataTableBtnRetry_${item.clave}`"
                  :paramnum="item.clave"
                  :showcustom="[VACH_STATUS_NUM_ENVIADO, VACH_STATUS_NUM_ERROR_ENVIO].includes(item.estatus) && $userPermission.hasPermission('ROLE_UPLOAD_VRSD')"
                  action="retry"
                  icon="fas fa-undo-alt"
                  :loading="loading.includes(item.clave)"
                  :clase="loading.length > 0 ? 'loading' : ''"
                  :title="$t('view.filetransaction.validator.buttons.retry')"
                  @retry="retry" />
              </template>

              <template #expanded-item="{ headers, item }">
                <td :colspan="headers.length">{{ item.detalle }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-expand-transition>
    <detalle-modal ref="detalleModal" />
  </v-card>
</template>
<script>
import FileTransactionAPI from "@/services/filetransaction/validator"; /** *******************************/
import Filters from "@/views/filetransaction/validator/Filters"; /** *******************************/
import detalleModal from "@/views/filetransaction/validator/DetalleModal"; /** *******************************/
import ButtonCustom from "@/components/datatable/ButtonCustom"; /** *******************************/
import ButtonDisable from "@/components/datatable/ButtonDisable"; /** *******************************/
import ButtonDownload from "@/components/datatable/ButtonDownload"; /** *******************************/
import ButtonErrors from "@/components/datatable/ButtonErrors"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import { deleteSwal } from "@/constants/sweet-alerts";
import { formatDateTime } from "@/helpers/date-methods";
import { handleResponse } from "@/helpers/http-response-handler";
import {
  VACH_STATUS_TABLE,
  VACH_STATUS,
  VACH_STATUS_NUM_ENVIADO,
  VACH_STATUS_NUM_PENDIENTE,
  VACH_STATUS_NUM_PROCESO,
  VACH_STATUS_NUM_ERROR,
  VACH_STATUS_NUM_ERROR_ENVIO,
  VACH_STATUS_NUM_VALIDADO,
  TIPO_ARCHIVO_NUM_CANAL,
  TIPO_ARCHIVO_NUM_DIM
} from "@/constants/operativos";

export default {
  components: {
    Filters
    , detalleModal
    , ButtonCustom
    , ButtonDisable
    , ButtonDownload
    , ButtonErrors
  }
  , data() {
    return {
      options: {}
      , expanded: []
      , filtros: {}
      , loading: []
      , search: ""
      , timer: undefined
      , autoreload: false
      , VACH_STATUS_TABLE
      , VACH_STATUS
      , VACH_STATUS_NUM_ENVIADO
      , VACH_STATUS_NUM_PENDIENTE
      , VACH_STATUS_NUM_PROCESO
      , VACH_STATUS_NUM_ERROR
      , VACH_STATUS_NUM_ERROR_ENVIO
      , VACH_STATUS_NUM_VALIDADO
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 50, 100, 1000] }
            , headers: [
              { text: "", value: "data-table-expand" }
              , { text: this.$t("view.filetransaction.validator.form.id.th"), align: "left", sortable: true, class: "clave", cellClass: "clave", value: "clave" }
              , { text: this.$t("view.filetransaction.validator.form.nombre.th"), align: "left", sortable: true, class: "nombre", cellClass: "nombre", value: "nombre" }
              , { text: this.$t("view.filetransaction.validator.form.subtipo.th"), align: "center", sortable: true, class: "subtipo", cellClass: "subtipo", value: "subtipo" }
              , { text: this.$t("view.filetransaction.validator.form.fecha.th"), align: "center", sortable: true, class: "fecha", cellClass: "fecha", value: "fecha" }
              , { text: this.$t("view.filetransaction.validator.form.estatus.th"), align: "center", sortable: true, class: "estatus", cellClass: "estatus", value: "estatus" }
              , { text: this.$t("view.filetransaction.validator.form.registros.th"), align: "center", sortable: true, class: "registros", cellClass: "registros", value: "registros" }
              , { text: this.$t("view.filetransaction.validator.form.usuarioalta.th"), align: "center", sortable: true, class: "usuarioalta", cellClass: "usuarioalta", value: "usuarioalta" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: false, class: "accion", cellClass: "accion", value: "accion" }
            ]
          }
        }
      }
    };
  }
  , computed: {
    computedHeaders() {
      return this.$userPermission.hasPermission("ROLE_TODOS_VACH") ? this.view.elem.datatable.headers : this.view.elem.datatable.headers.filter((column) => column.value != "usuarioalta");
    }
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
    , search: {
      handler() {
        this.options.page = 1;
        this.load();
      }
      , deep: true
    }
  }
  , created() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      if (this.autoreload) this.load();
    }, 1000 * 10);
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , destroyed() {
    if (this.timer) clearInterval(this.timer);
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      if (!this.$userPermission.hasPermission("ROLE_TODOS_VACH")) {
        this.filtros.username = this.$store.getters.getUserData ? this.$store.getters.getUserData.username : [];
      }

      this.filtros.tipo = this.getTipoFilter();

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;
      this.$refs.filters.loading(true);

      const serverSideDataT = this.prepareData();
      const response = await FileTransactionAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
      this.$refs.filters.loading(false);
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.options.page = 1;
      this.filtros = fls;
      await this.load();
    }
    , async detail(item) {
      const file = { ...item };
      file.detalle = JSON.parse(file.detalle);
      this.$refs.detalleModal.open(file);
    }
    , async disable(clave) {
      if ((await this.$swal(deleteSwal)).value) {
        if (!this.loading.includes(clave)) this.loading.push(clave);
        this.load();
        const response = await FileTransactionAPI.disable({ clave });
        this.loading = this.loading.filter(function (value) {
          return value != clave;
        });
        if (handleResponse(response)) this.load();
      }
    }
    , async download(clave) {
      if (!this.loading.includes(clave)) this.loading.push(clave);
      this.load();
      try {
        const response = await FileTransactionAPI.download(clave);
        const url = globalThis.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", response.headers.filename); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", "Error al descargar archivo");
        console.error(error);
      }
      this.loading = this.loading.filter(function (value) {
        return value != clave;
      });
      this.load();
    }
    , async errors(clave) {
      if (!this.loading.includes(clave)) this.loading.push(clave);
      this.load();
      try {
        const response = await FileTransactionAPI.errors(clave);
        const url = globalThis.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", response.headers.filename); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", "Error al descargar archivo");
        console.error(error);
      }
      this.loading = this.loading.filter(function (value) {
        return value != clave;
      });
      this.load();
    }
    , async retry(clave) {
      await FileTransactionAPI.retry(clave);
      this.load();
    }
    , getTipoFilter() {
      let tipos = [];
      if (this.$userPermission.hasPermission("ROLE_ACCESO_TIPO_CANAL") || this.$userPermission.hasPermission("ROLE_TODOS_VACH")) tipos.push(TIPO_ARCHIVO_NUM_CANAL);
      if (this.$userPermission.hasPermission("ROLE_ACCESO_TIPO_DIM") || this.$userPermission.hasPermission("ROLE_TODOS_VACH")) tipos.push(TIPO_ARCHIVO_NUM_DIM);
      return tipos.length > 0 ? tipos.join() : "n/a";
    }
    , refreshData() {
      this.load();
    }
    , formatDateTime
  }
};
</script>

<style>
.validator .clave {
  width: 130px !important;
  min-width: 130px !important;
  padding-left: 0 !important;
}

.validator .subtipo {
  min-width: 100px !important;
}

.validator .estatus {
  min-width: 110px !important;
}

.validator .registros {
  min-width: 110px !important;
}

.validator .accion {
  width: 180px !important;
  min-width: 180px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/filetransaction/validator/DataTable.vue